<template>
  <file-modal></file-modal>
</template>

<script>
  import 'jquery-validation'
  import FileModal from '../components/FileModal'
  
  export default {
    name: 'RegisterFinancing',
    components: {
      FileModal,
    },
    mounted() {
      /**
       * select2 - Search funders
       */
      const $search = $('.search-select-funders')
      $search.select2({
        ajax: {
          url: '/api/v1/funders',
          dataType: 'json',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data(params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults(data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })
      
      /**
       * Init JQuery validation
       */
      $(document).ready(function() {
        $('.form').validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            has_financing: {
              required: true,
              maxlength: 255,
            },
            other_means: {
              required: function() {
                return $('[name="has_financing"]:checked').val() === ''
              },
            },
            'funders[]': {
              required: function() {
                return $('[name="has_financing"]:checked').val() !== ''
              },
            },
          },
          messages: {
            has_financing: {
              required: 'Este campo es requerido.',
              maxlength: 'El texto no debe superar los 255 caracteres.',
            },
            other_means: {
              required: 'Este campo es requerido.',
            },
            'funders[]': {
              required: 'Es necesario agregar por lo menos una financiadora.',
            },
          },
          submitHandler(form) {
            form.submit()
          },
        })
      })
      
      /**
       * Show and hide inputs of financing form
       */
      showFinaningInputs($('input[name="has_financing"]:checked').val())
      
      $('input[name="has_financing"]').on('click', function() {
        showFinaningInputs($(this).val())
      })
      
      function showFinaningInputs(value) {
        if(value == !true) {
          $('.has-not').removeClass('d-none')
          $('.has').addClass('d-none')
        }
        else {
          $('.has-not').addClass('d-none')
          $('.has').removeClass('d-none')
        }
      }
      
      /**
       * Add funder
       */
      $('#add-funder').on('click', function() {
        addFunder()
      })
      
      function addFunder() {
        var formatter = new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency: 'MXN',
        })
        var value     = $('#funder option:selected').val()
        var target    = value + '-file'
        var info      = value + '-info'
        var id        = value + '-id'
        var item      = '<li class="d-flex">' +
          '<i class="delete-funder fas fa-trash-alt mr-2" data-value="' + value + '"></i>' +
          '<div class="text">' +
          '<h6>' + $('#funder option:selected').text() + '</h6>' +
          '<p>' + formatter.format($('#budget').val()) + '</p>' +
          '<a id="' + id + '" class="file-btn" data-target="' + target + '" data-info="' + info + '" data-text="Incorpore el convenio."><i class="fas fa-file-upload"></i> Agregar convenio</a>' +
          '<div class="file-info ' + info + ' d-none">' +
          '<span class="text"></span>' +
          '<i class="fas fa-times text-danger remove-file" data-target="' + id + '"></i>' +
          '</div>' +
          '<input class="d-none" type="file" name="' + target + '" data-id="' + target + '" />' +
          '<div>' +
          '</li>'
        
        if($('#budget').val() !== '' && $('#funder').val() !== '') {
          $('#funder-list ul').append(item)
          $('#funder-list .empty-message').addClass('d-none')
          
          const jsonValue = {
            funder_id: value,
            budget: $('#budget').val(),
            agreement: target,
          }
          $('#funders').append('<option selected data-value=' + value + '" value=\'' + JSON.stringify(jsonValue) + '\'>' + value + '</option>')
          
          $('#budget').val('')
          $('#funder').val(null).trigger('change')
        }
      }
      
      /**
       * Delete funder
       */
      $('body').on('click', '.delete-funder', function() {
        $(this).parents('li').hide('slow', function() {
          this.remove()
        })
        $('#funders option[data-value="' + $(this).attr('data-value') + '"]').remove()
        
        if($('#funders option').length < 1) {
          $('#funder-list .empty-message').removeClass('d-none')
        }
      })
    },
  }
</script>
